import { Roles } from '~/stores/usersStore';
import { RolesRolesOptions } from '~/composables/pocketbase.types';

export default defineNuxtRouteMiddleware(async (to) => {
  if (process.server) {
    return;
  }

  let requiredRoles = to.meta.anyRequiredRoles as Roles | Roles[] | undefined;
  if (!requiredRoles) {
    return;
  }
  if (!Array.isArray(requiredRoles)) {
    requiredRoles = [requiredRoles];
  }

  const pb = usePocketBase();
  if (!pb.authStore.isValid) {
    return navigateTo({
      path: '/user/login',
      query: { redirect: to.fullPath },
    });
  }

  const usersStore = useUsersStore();
  await usersStore.refreshCurrentUser();
  const userRoles = usersStore.currentUser?.roles ?? [];
  const hasAnyRole = requiredRoles.some((role) =>
    userRoles.includes(RolesRolesOptions[role]),
  );
  if (!hasAnyRole) {
    return navigateTo('/user/no-access');
  }
});
